import { render } from "./AlFilo.vue?vue&type=template&id=c7c29ffe"
import script from "./AlFilo.vue?vue&type=script&lang=js"
export * from "./AlFilo.vue?vue&type=script&lang=js"

import "./AlFilo.vue?vue&type=style&index=0&id=c7c29ffe&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__